export function ForbiddenPage() {
    return (
        <div style={{ maxWidth: '420px', margin: '80px auto', textAlign: 'center' }}>
            <h1 style={{ fontSize: '2rem', marginBottom: '1rem' }}>Access denied</h1>
            <p style={{ color: '#555' }}>You do not have permission to view this page. Contact an administrator if you believe this is a mistake.</p>
        </div>
    );
}
